// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/course_section_role.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/course_section_role.proto.
 */
export const file_studyo_today_planners_v1_resources_course_section_role = /*@__PURE__*/
  fileDesc("CjxzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2NvdXJzZV9zZWN0aW9uX3JvbGUucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMqegoRQ291cnNlU2VjdGlvblJvbGUSIwofQ09VUlNFX1NFQ1RJT05fUk9MRV9VTlNQRUNJRklFRBAAEh8KG0NPVVJTRV9TRUNUSU9OX1JPTEVfU1RVREVOVBABEh8KG0NPVVJTRV9TRUNUSU9OX1JPTEVfVEVBQ0hFUhACQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.planners.v1.resources.CourseSectionRole.
 */
export const CourseSectionRoleSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_course_section_role, 0);

/**
 * All possible roles of a user in a CourseSection.
 *
 * @generated from enum studyo.today.planners.v1.resources.CourseSectionRole
 */
export const CourseSectionRole = /*@__PURE__*/
  tsEnum(CourseSectionRoleSchema);

